import Api from "../../api/Api";
import { toast } from "react-toastify";
import {
  ADD_IDQ_SUCCESS,
  DELETE_IDQ_SUCCESS,
  GET_IDQ_SUCCESS,
  UPDATE_IDQ_SUCCESS,
} from "./actionTypes";

const getListParams = (params, state) => ({
  page: params.page ?? state?.pagination?.page ?? 1,
  per_page: params.per_page ?? state?.pagination?.per_page ?? 10,
  search: params.search ?? state?.pagination?.search ?? "",
  scope: params.scope ?? "list",
  silent: params.silent ?? false,
});

const getResponseBody = (response) => response?.data ?? response;

const toList = (value) => (Array.isArray(value) ? value : []);

const buildSuccessPayload = (response, { search, scope }) => {
  const data = getResponseBody(response);
  const items = toList(data.data);

  const payload = {
    total: data.total ?? items.length,
    page: data.page ?? 1,
    per_page: data.per_page ?? 10,
    search,
    scope,
  };

  if (scope === "defective") {
    payload.defective = items;
  } else {
    payload.apples = items;
  }

  return payload;
};

const reloadAppleQList = (dispatch, getState, overrides = {}) => {
  const { pagination } = getState().IDQ;
  dispatch(
    loadAppleQ({
      page: pagination?.page ?? 1,
      per_page: pagination?.per_page ?? 10,
      search: pagination?.search ?? "",
      scope: "list",
      silent: true,
      ...overrides,
    })
  );
};

export const loadAppleQ = (params = {}) => (dispatch, getState) => {
  const listState = getState().IDQ;
  const { page, per_page, search, scope, silent } = getListParams(
    params,
    listState
  );

  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;

  const req = Api.get("/appleq/get", {
    params: { page, per_page, search, scope },
  });

  const onSuccess = (data) => {
    dispatch({
      payload: buildSuccessPayload(data, { search, scope }),
      type: GET_IDQ_SUCCESS,
    });
  };

  if (silent) {
    req.then((response) => onSuccess(response)).catch(() => {});
    return;
  }

  toast.promise(req, {
    pending: "Getting Apple IDs...",
    success: {
      render({ data: response }) {
        onSuccess(response);
        return "Your Data Is Ready";
      },
    },
    error: {
      render() {
        return "An error occurred while getting Apple IDs";
      },
    },
  });
};

export const addAppleQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/add", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleQList(dispatch, getState, { page: 1 });
        return "Apple ID added successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const updateAppleQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_IDQ_SUCCESS,
        });
        reloadAppleQList(dispatch, getState);
        return "Apple ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your Apple ID";
      },
    },
  });
};

export const deleteAppleQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleQList(dispatch, getState);
        return "Apple ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple ID";
      },
    },
  });
};

export const soldAppleQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/sold", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleQList(dispatch, getState);
        return "Apple ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your Apple ID";
      },
    },
  });
};

export const importAppleQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  Api.defaults.headers.common["Content-Type"] = "multipart/form-data";
  let req = Api.post("/appleq/import", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleQList(dispatch, getState, { page: 1, search: "" });
        return "Apple ID imported successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const exportAppleQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/export", { number: data.formData.number });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        reloadAppleQList(dispatch, getState, { page: 1 });
        window.open(response.data.data, "_blank");
        return "Apple ID exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const exportAppleQrQ = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/export/qr", {
    number: data.number,
    image: data.image,
    shownote: data.shownote,
    note: data.note,
  });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        reloadAppleQList(dispatch, getState, { page: 1 });
        window.open(response.data.data, "_blank");
        return "Apple ID exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const fixApple = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/fix", { accounts: data.formData.accounts });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleQList(dispatch, getState, { page: 1 });
        return "Apple IDs fixed successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const deleteAppleDefective = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/appleq/delete/defective", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        dispatch(
          loadAppleQ({
            scope: "defective",
            page: getState().IDQ.pagination?.page ?? 1,
            per_page: getState().IDQ.pagination?.per_page ?? 10,
            search: getState().IDQ.pagination?.search ?? "",
            silent: true,
          })
        );
        return "Apple ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple ID";
      },
    },
  });
};
